import { render, staticRenderFns } from "./transectionBookingDetailPage.vue?vue&type=template&id=6bd6bd2a&"
import script from "./transectionBookingDetailPage.vue?vue&type=script&lang=js&"
export * from "./transectionBookingDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports